import React from 'react'
import ReduxBlockUi from 'react-block-ui/redux'
import { connect } from 'react-redux'

import 'react-block-ui/style.css'

import { enableUIBlock, disableUIBlock } from 'Reducers/UIBlock/actions'

import {
  INCREMENT_BLOCK_COUNTER,
  DECREMENT_BLOCK_COUNTER,
} from 'Reducers/UIBlock/const'

class UIBlockUnstyled extends React.Component {
  constructor(props) {
    super(props)

    this.handleOnChange = this.handleOnChange.bind(this)
  }

  render() {
    const { children, className } = this.props

    return (
      <ReduxBlockUi
        block={INCREMENT_BLOCK_COUNTER}
        className={className}
        onChange={this.handleOnChange}
        unblock={DECREMENT_BLOCK_COUNTER}
      >
        {children}
      </ReduxBlockUi>
    )
  }

  handleOnChange(newValue, oldValue) {
    const { disableUIBlock, enableUIBlock } = this.props

    if (oldValue === 0 && newValue > 0) {
      enableUIBlock()
    }

    if (oldValue > 0 && newValue === 0) {
      disableUIBlock()
    }
  }
}

export default connect(
  null,
  {
    enableUIBlock,
    disableUIBlock,
  },
)(UIBlockUnstyled)
